import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ProductViewPage } from '../../../products/product-view/product-view/product-view';
import { DishViewPage } from '../../../dish/dish-view/dish-view/dish-view';
import { MenuCreateCustomizeViewPage } from '../../../menu/menu-view/menu-create-customize-view';

/**
 * Generated class for the HomeDashboardTopopSalesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-home-dashboard-top-sales',
  templateUrl: 'home-dashboard-top-sales.html',
})
export class HomeDashboardTopSalesPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public http: HttpClient, ) {

    this.mostSalesElements30days();
  }

  elements_sales: any = [];
  data_elements: boolean = false;
  async mostSalesElements30days() {
    const body = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('lang', this.globals.restaurant.lang);

    await this.http.post(this.globals.analytics_path + 'most-sales-elements-30-days', body,{}).subscribe(async data => {
      this.elements_sales = data;
      this.data_elements = true;
    },
      err => {
      }
    );
  }
  openItem(item) {
    if (item.type == 'dish') {
      this.navCtrl.push(DishViewPage, {
        dish_uid: item.uid,
        dish_name: item.name_es,
        dish_price: item.price
      });
    } else if (item.type == 'product') {
      this.navCtrl.push(ProductViewPage, {
        product_uid: item.uid,
        product_name: item.name,
        product_sub_recipe: item.sub_recipe
      });
    } else {
      this.navCtrl.push(MenuCreateCustomizeViewPage, {
        menu_uid: item.uid,
    })
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-dashboard-top-sales/home-dashboard-top-sales.ts